import Vue from 'vue';
import VueRouter from 'vue-router';
import { isMobile } from 'mobile-device-detect';
import Mobile from '../views/Mobile.vue';
import Desktop from '../views/Desktop.vue';
import SmartTV from '../views/SmartTV.vue';
import UniversalMobile from '../views/UniversalMobile.vue';
import Screenshot from '../views/Screenshot.vue';
import NotFound from '../views/NotFound.vue';
import Documentation from '../views/Documentation.vue';
import Requirements from '../views/TechnicalRequirements.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/mobile/mobileNativeUnit',
  },
  {
    path: '/mobile',
    redirect: '/mobile/mobileNativeUnit',
  },
  {
    path: '/desktop',
    redirect: '/desktop/inReadVideoStandart',
  },
  {
    path: '/mobile/:m_id?',
    name: 'Mobile',
    component: Mobile,
    props: true,
  },
  {
    path: '/desktop/:d_id?',
    name: 'Desktop',
    component: Desktop,
    props: true,
  },
  {
    path: '/universalMobile',
    name: 'UniversalMobile',
    component: UniversalMobile,
    props: true,
  },
  {
    path: '/screenshot/:site',
    name: 'Screenshot',
    component: Screenshot,
    props: true,
  },
  {
    path: '/smarttv',
    name: 'SmartTV',
    component: SmartTV,
  },
  {
    path: '/documentation/:doc_id',
    name: 'Documentation',
    component: Documentation,
    props: true,
  },
  {
    path: '/documentation/requirements/:id',
    name: 'Requirements',
    component: Requirements,
    props: true,
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.name === 'Documentation' && to.params.doc_id === 'validator' && isMobile) {
    next('/documentation/instructions');
  }
  if (to.name === 'Desktop' && isMobile) {
    next('/mobile/mobileNativeUnit');
  }
  if (to.name === 'Desktop' && to.hash) {
    const newPath = to.fullPath;
    switch (to.hash) {
      case '#tinkoff':
        next(newPath.replace(/#tinkoff/g, 'inReadVideoStandart'));
        break;
      case '#lvmh':
        next(newPath.replace(/#lvmh/g, 'inReadVideoCustombutton'));
        break;
      case '#garage':
        next(newPath.replace(/#garage/g, 'inReadVideoSocialbuttons'));
        break;
      case '#apple':
        next(newPath.replace(/#apple/g, 'inReadBanner'));
        break;
      case '#brand-lift':
        next(newPath.replace(/#brand-lift/g, 'brandLift2'));
        break;
      default:
        break;
    }
  } else if (to.fullPath === '/wrap' || to.fullPath === '/wrap/') {
    next('/mobile/mobileNativeUnit');
  } else if (to.path === '/wrap/' && to.hash) {
    let id = `${to.hash.charAt(1).toLowerCase()}${to.hash.slice(2)}`;
    if (to.hash === '#Benefit') id = 'benefitBanner';
    next({
      name: 'Mobile',
      params: {
        m_id: id,
      },
    });
  }
  next();
});

export default router;
